import {
  ClusterOutlined,
  EnvironmentOutlined,
  EuroOutlined,
  FileUnknownOutlined,
  FormOutlined,
  GatewayOutlined,
  MailOutlined,
  StopOutlined,
  TagsOutlined,
  UsergroupAddOutlined
} from '@ant-design/icons'
import { useAppNavigate } from '@crm/hooks/useAppNavigate'
import { paths } from '@crm/routes'
import { getActivePath } from '@crm/utils'
import { Col, Menu, Row } from 'antd'

import { useTranslation } from 'react-i18next'
import { Outlet, useLocation } from 'react-router-dom'

import type { MenuProps } from 'antd/lib'

export const NomenclaturesGeneral = () => {
  const { pathname } = useLocation()
  const { t } = useTranslation()
  const navigate = useAppNavigate()

  const items: MenuProps['items'] = [
    {
      key: paths.admin.nomenclatures.general.root,
      label: t('nomenclature.industries'),
      icon: <ClusterOutlined size={20} />,
      onClick: ({ key }) => navigate(key)
    },
    {
      key: paths.admin.nomenclatures.general.reasons,
      label: t('nomenclature.reasons'),
      icon: <StopOutlined size={20} />,
      onClick: ({ key }) => navigate(key)
    },
    {
      key: paths.admin.nomenclatures.general.sizes,
      label: t('nomenclature.sizes'),
      icon: <GatewayOutlined size={20} />,
      onClick: ({ key }) => navigate(key)
    },
    {
      key: paths.admin.nomenclatures.general.currencies,
      label: t('nomenclature.currencies'),
      icon: <EuroOutlined size={20} />,
      onClick: ({ key }) => navigate(key)
    },
    {
      key: paths.admin.nomenclatures.general.documents,
      label: t('nomenclature.documents'),
      icon: <FileUnknownOutlined size={20} />,
      onClick: ({ key }) => navigate(key)
    },
    {
      key: paths.admin.nomenclatures.general.emailTemplates,
      label: t('account_settings.email_templates'),
      icon: <MailOutlined size={20} />,
      onClick: ({ key }) => navigate(key)
    },
    {
      key: paths.admin.nomenclatures.general.mailboxesAuth,
      label: t('nomenclature.mailboxes'),
      icon: <MailOutlined size={20} />,
      onClick: ({ key }) => navigate(key)
    },
    {
      key: paths.admin.nomenclatures.general.tags,
      label: t('nomenclature.tags'),
      icon: <TagsOutlined size={20} />,
      onClick: ({ key }) => navigate(key)
    },
    {
      key: paths.admin.nomenclatures.general.countries,
      label: t('nomenclature.countries'),
      icon: <EnvironmentOutlined size={20} />,
      onClick: ({ key }) => navigate(key)
    },
    {
      key: paths.admin.nomenclatures.general.seniorPositions,
      label: t('nomenclature.senior_positions'),
      icon: <UsergroupAddOutlined size={20} />,
      onClick: ({ key }) => navigate(key)
    },
    {
      key: paths.admin.nomenclatures.general.customFields,
      label: t('nomenclature.custom_fields'),
      icon: <FormOutlined size={20} />,
      onClick: ({ key }) => navigate(key)
    }
  ]

  return (
    <Row gutter={16} wrap={false}>
      <Col xs={8} lg={7} xl={6} xxl={5}>
        <Menu items={items} defaultSelectedKeys={[getActivePath(pathname)]} />
      </Col>

      <Col flex="auto">
        <Outlet />
      </Col>
    </Row>
  )
}
